import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Avatar, AvatarProps, Modal, rem } from '@mantine/core'
export const StyledHomeTrustfulItemLabel = styled.div``

export const StyledHomeTrustfulItemDescription = styled.p`
color: ${theme.colors.gray600};
margin: 0;
font-size; ${rem(14)};
letter-spacing: -0.2px;
`

export const StyledHomeTrustfulItemContent = styled.div`
  flex: 1;
  min-width: 0;

  > ${StyledHomeTrustfulItemDescription} {
    margin-top: ${rem(4)};
  }
`

export const StyledHomeTrustfulItemIcon = styled.img`
  width: ${rem(20)};
  height: ${rem(20)};
  object-fit: contain;
  object-position: center;

  ${MediaQueries.mbDown} {
    & {
      margin-top: ${rem(2)};
    }
  }
`

export const StyledHomeTrustfulItem = styled.div`
  display: flex;
  gap: ${rem(4)};
  flex-wrap: wrap;
  align-items: center;
  color: ${theme.colors.gray800};
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  letter-spacing: -0.5px;

  ${MediaQueries.mbDown} {
    & {
      width: 100%;
      gap: ${rem(8)};
      align-items: flex-start;
      padding-top: ${rem(14)};

      > ${StyledHomeTrustfulItemLabel} {
        flex: 1;
        min-width: 0;
        padding-bottom: ${rem(14)};
        border-bottom: 1px solid ${theme.colors.neutral100};
      }
    }
  }
`

export const StyledHomeTrustfulTitleAvatar = styled(Avatar)<AvatarProps>`
  margin-top: ${rem(4)};
`

export const StyledHomeTrustfulTitle = styled.p`
  display: flex;
  gap: ${rem(8)};
  font-size: ${rem(18)};
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 0;

  ${MediaQueries.smbDown} {
    & {
      gap: ${rem(12)};
    }
  }
`

export const StyledHomeTrustfulModal = styled(Modal)`
  &.mantine-Modal-root {
    .mantine-Overlay-root {
      z-index: 306;
    }

    .mantine-Modal-inner {
      z-index: 306;
    }

    .mantine-Modal-content {
      flex-basis: ${rem(552)};

      .mantine-Modal-header {
        padding-inline: ${rem(32)};
        padding-top: ${rem(32)};
        padding-bottom: ${rem(24)};
      }

      .mantine-Modal-body {
        padding-inline: ${rem(32)};
        padding-bottom: ${rem(32)};
      }

      ${StyledHomeTrustfulTitle} {
        gap: ${rem(12)};
        align-items: center;
      }

      ${StyledHomeTrustfulTitleAvatar} {
        width: ${rem(32)};
        height: ${rem(32)};
        margin-top: 0;
      }

      ${StyledHomeTrustfulItemIcon} {
        width: ${rem(48)};
        height: ${rem(48)};
      }

      ${StyledHomeTrustfulItemLabel} {
        color: ${theme.colors.gray800};
        font-size: ${rem(18)};
        line-height: 1.5;
        font-weight: 600;
      }

      ${StyledHomeTrustfulItemContent} {
        + ${StyledHomeTrustfulItemDescription} {
          display: none;
        }
      }

      ${StyledHomeTrustfulItem} {
        padding-block: ${rem(16)};
        gap: ${rem(16)};
        align-items: flex-start;

        + ${StyledHomeTrustfulItem} {
          border-top: 1px solid ${theme?.colors?.neutral100};
        }
      }
    }
  }

  ${MediaQueries.mbDown} {
    &.mantine-Modal-root {
      .mantine-Modal-inner {
        padding: 0 !important;
        align-items: flex-end;
      }
      .mantine-Modal-content {
        flex-basis: 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        .mantine-Modal-header {
          padding: ${rem(16)};
          border-bottom: 1px solid ${theme.colors.neutral100};
        }

        .mantine-Modal-body {
          padding-inline: 0;
          padding-bottom: 0;
        }

        ${StyledHomeTrustfulTitle} {
          font-size: ${rem(16)};
        }

        ${StyledHomeTrustfulTitleAvatar} {
          width: ${rem(24)};
          height: ${rem(24)};
        }

        ${StyledHomeTrustfulItemIcon} {
          width: ${rem(24)};
          height: ${rem(24)};
        }

        ${StyledHomeTrustfulItemLabel} {
          color: ${theme.colors.gray800};
          font-sizt: ${rem(16)};
          line-height: 1.5;
          font-weight: 600;
        }

        ${StyledHomeTrustfulItemContent} {
          + ${StyledHomeTrustfulItemDescription} {
            display: block;
          }
          > ${StyledHomeTrustfulItemDescription} {
            display: none;
          }
        }

        ${StyledHomeTrustfulItem} {
          padding: ${rem(16)};
          gap: ${rem(16)};
          row-gap: ${rem(8)};
          align-items: center;
          + ${StyledHomeTrustfulItem} {
            border-top: 1px solid ${theme?.colors?.neutral100};
          }
        }
      }
    }
  }
`
